export default "__VITE_ASSET__D7Rfaljw__"